import {
  EarningsIcon,
  FilmIcon,
  HomeIcon,
  InfoIcon,
  PerformanceIcon,
  PlusIcon,
  BulkIcon,
} from 'components/shared/Icons'

// export const API_URL = `https://shamimediagroup.com/api/filmmaker/`
export const API_URL = `https://o1j0okg6yj.execute-api.ap-southeast-2.amazonaws.com/`
export const USER_TABLE = `filmmaker-dash-users`

export const authData = [
  {
    route: '/signup',
    title: 'Welcome to Filmmaker Dash!',
    subtitle: 'Create an account to get started.',
  },
  {
    route: '/login',
    title: 'Login to Filmmaker Dash!',
    subtitle: 'Good to see you again.',
  },
  {
    route: '/confirm-signup',
    title: 'Confirm Signup',
    subtitle: 'Check your email for the confirmation code.',
  },
  {
    route: '/forgot-password',
    title: 'Forgot Password',
    subtitle: `No worries, We'll send you reset instructions`,
  },
  {
    route: '/reset-password',
    title: 'Reset Password',
    subtitle: `Set your new password`,
  },
]

export const sidebarData = [
  {
    title: 'Menu',
    route: '',
    icon: HomeIcon,
    routes: [
      // {
      //   route: '/add-submission',
      //   name: 'add submission',
      //   icon: PlusIcon,
      // },
      {
        route: '/my-submissions',
        name: 'my submissions',
        icon: FilmIcon,
      },
      {
        route: '/analytics',
        name: 'Analytics',
        icon: PerformanceIcon,
      },
      // {
      //   route: '/bulk-submissions',
      //   name: 'Bulk Submissions',
      //   icon: BulkIcon,
      // },
      {
        route: '/guides',
        name: 'Guides',
        icon: InfoIcon,
      },
      // {
      //   route: '/earnings',
      //   name: 'Earnings',
      //   icon: EarningsIcon,
      // },
    ],
  },
  // {
  //   title: 'admin',
  //   route: '/admin',
  //   icon: KeyIcon,
  //   routes: [
  //     {
  //       route: '/qc',
  //       name: 'quality check',
  //       icon: QCIcon,
  //     },
  //     {
  //       route: '/pending',
  //       name: 'pending',
  //       icon: PendingIcon,
  //     },
  //   ],
  // },
  // {
  //   title: 'auth',
  //   route: '/admin',
  //   icon: AuthIcon,
  //   routes: [
  //     {
  //       route: '/users',
  //       name: 'users',
  //       icon: UserIcon,
  //     },
  //   ],
  // },
]

export const genres = [
  { name: 'Action/Adventure' },
  { name: 'Animation' },
  { name: 'Comedy' },
  { name: 'Crime' },
  { name: 'Documentary' },
  { name: 'Fantasy' },
  { name: 'Horror' },
  { name: 'Informational & Educational' },
  { name: 'Music & Performances' },
  { name: 'Mystery' },
  { name: 'Reality Show' },
  { name: 'Sci-Fi' },
  { name: 'Sport & Fitness' },
  { name: 'Thriller' },
  { name: 'Unknown' },
  { name: 'War' },
  { name: 'Western' },
]
export const languages = [
  { name: 'Afrikaans' },
  { name: 'Akan' },
  { name: 'Albanian' },
  { name: 'Amharic' },
  { name: 'Arabic' },
  { name: 'Armenian' },
  { name: 'Azerbaijani' },
  { name: 'Basque' },
  { name: 'Belarusian' },
  { name: 'Bengali' },
  { name: 'Bosnian' },
  { name: 'Bulgarian' },
  { name: 'Burmese' },
  { name: 'Cambodian Khmer' },
  { name: 'Catalan' },
  { name: 'Croatian' },
  { name: 'Czech' },
  { name: 'Danish' },
  { name: 'Dari' },
  { name: 'Dutch' },
  { name: 'Estonian' },
  { name: 'English' },
  { name: 'Farsi' },
  { name: 'Filipino' },
  { name: 'Finnish' },
  { name: 'French' },
  { name: 'Gaelic' },
  { name: 'Galician' },
  { name: 'Georgian' },
  { name: 'German' },
  { name: 'Greek' },
  { name: 'Guarani' },
  { name: 'Gujarati' },
  { name: 'Hebrew' },
  { name: 'Hindi' },
  { name: 'Hungarian' },
  { name: 'Icelandic' },
  { name: 'Indonesian' },
  { name: 'Italian' },
  { name: 'Japanese' },
  { name: 'Javanese' },
  { name: 'Kannada' },
  { name: 'Kazakh' },
  { name: 'Korean' },
  { name: 'Kurdish' },
  { name: 'Latvian' },
  { name: 'Lithuanian' },
  { name: 'Luxembourgish' },
  { name: 'Macedonian' },
  { name: 'Malay' },
  { name: 'Malayalam' },
  { name: 'Maltese' },
  { name: 'Mandarin (Spoken)' },
  { name: 'Manipuri' },
  { name: 'Marathi' },
  { name: 'Moldovan' },
  { name: 'Mongolian' },
  { name: 'Nepali' },
  { name: 'No Language' },
  { name: 'Norwegian' },
  { name: 'Odia' },
  { name: 'Pashto' },
  { name: 'Polish' },
  { name: 'Portuguese' },
  { name: 'Portuguese (Brazil)' },
  { name: 'Punjabi' },
  { name: 'Romanian' },
  { name: 'Russian' },
  { name: 'Samoan' },
  { name: 'Serbian' },
  { name: 'Slovak' },
  { name: 'Slovenian' },
  { name: 'Somali' },
  { name: 'Southern Balochi' },
  { name: 'Spanish (Latin America)' },
  { name: 'Spanish (Spain)' },
  { name: 'Swahili' },
  { name: 'Swedish' },
  { name: 'Tagalog' },
  { name: 'Tajik' },
  { name: 'Tamil' },
  { name: 'Telugu' },
  { name: 'Thai' },
  { name: 'Turkish' },
  { name: 'Turkmen' },
  { name: 'Ukrainian' },
  { name: 'Unknown' },
  { name: 'Urdu' },
  { name: 'Uzbek' },
  { name: 'Vietnamese' },
  { name: 'Xhosa' },
  { name: 'Yiddish' },
  { name: 'Yoruba' },
  { name: 'Zulu' },
]

export const subgenres = [
  { name: 'Action' },
  { name: 'Adventure' },
  { name: 'Bollywood' },
  { name: 'Christmas' },
  { name: 'Courtroom / Legal Drama' },
  { name: 'Crime' },
  { name: 'Disaster' },
  { name: 'Drama' },
  { name: 'Educational' },
  { name: 'Experimental' },
  { name: 'Faith and Religion' },
  { name: 'Family' },
  { name: 'Fantasy' },
  { name: 'Film Noir' },
  { name: 'Gangster' },
  { name: 'History' },
  { name: 'Horror' },
  { name: 'Japanimation' },
  { name: 'Kids' },
  { name: 'LGBTQ+' },
  { name: 'Martial Arts' },
  { name: 'Military' },
  { name: 'Mockumentary' },
  { name: 'Music' },
  { name: 'Musical' },
  { name: 'Mystery' },
  { name: 'Period Drama' },
  { name: 'Pirates' },
  { name: 'Procedural Drama' },
  { name: 'Romance / Love' },
  { name: 'Rom-Com' },
  { name: 'Sex' },
  { name: 'Sports' },
  { name: 'Superhero' },
  { name: 'Suspense' },
  { name: 'War' },
  { name: 'Western' },
]

export const formats = [
  { name: 'Feature Film' },
  { name: 'Short Film' },
  { name: 'Documentary' },
  { name: 'Episodic Show' },
]

export const moods = [
  { name: 'Anger' },
  { name: 'Anxiety' },
  { name: 'Calm' },
  { name: 'Exciting' },
  { name: 'Fear' },
  { name: 'Feel-good' },
  { name: 'Funny' },
  { name: 'Joy' },
  { name: 'Powerful' },
  { name: 'Sad' },
]

export const keywords = [
  { name: 'Alfred Hitchcock' },
  { name: 'Christopher Nolan' },
  { name: 'David Lynch' },
  { name: 'Kevin Smith' },
  { name: 'Pixar' },
  { name: 'Quentin Tarantino' },
  { name: 'Spinal Tap' },
  { name: 'Star Wars' },
  { name: 'The Matrix' },
  { name: 'Wong Kar-Wai' },
  { name: '3D Animation' },
  { name: 'Adult Animation' },
  { name: 'Black Cinema' },
  { name: 'Absurd' },
  { name: 'Bar' },
  { name: 'Betrayal' },
  { name: '16th Century' },
  { name: 'Advocacy' },
  { name: 'Father' },
  { name: 'Amusing' },
  { name: 'Beach' },
  { name: 'Coming of Age' },
  { name: '18th Century' },
  { name: 'Agriculture' },
  { name: 'Ambient Video' },
  { name: 'Gay' },
  { name: 'Awkward' },
  { name: 'College' },
  { name: 'Doppelganger' },
  { name: 'Irish' },
  { name: 'Bleak' },
  { name: 'Friendship' },
  { name: 'Courtroom' },
  { name: '1920s' },
  { name: 'Aliens' },
  { name: 'Latinx' },
  { name: 'Campy' },
  { name: 'Gym' },
  { name: 'Good Vs Evil' },
  { name: '1940s' },
  { name: 'Apocalypse' },
  { name: 'LGBTQIA+' },
  { name: 'Cheeky' },
  { name: 'High School' },
  { name: 'Grief' },
  { name: '1950s' },
  { name: 'Arts & Culture' },
  { name: 'Mother' },
  { name: 'Disturbing' },
  { name: 'Kitchen' },
  { name: 'Redemption' },
  { name: '1960s' },
  { name: 'Baseball' },
  { name: 'Native American' },
  { name: 'Dreamy' },
  { name: 'Office' },
  { name: 'Revenge' },
  { name: '1970s' },
  { name: 'Basketball' },
  { name: 'Siblings' },
  { name: 'Teenagers' },
  { name: 'Edgy' },
  { name: 'Outer Space' },
  { name: 'Rivalry' },
  { name: '1980s' },
  { name: 'Beer' },
  { name: 'Family Friendly' },
  { name: 'Educational' },
  { name: 'Restaurant' },
  { name: 'Road Trip' },
  { name: '1990s' },
  { name: 'Bigfoot' },
  { name: 'Women Filmmakers' },
  { name: 'Feel-Good' },
  { name: 'Small Town' },
  { name: '2000s' },
  { name: 'Cancer' },
  { name: 'Experimental' },
  { name: 'Epic' },
  { name: 'Erotic' },
  { name: 'Inspirational' },
  { name: 'Gritty' },
  { name: 'Christmas' },
  { name: "Children's Education" },
  { name: 'French New Wave' },
  { name: 'Mild Ages' },
  { name: 'Near Future' },
  { name: "St Patrick's Day" },
  { name: 'Cycling' },
  { name: 'Gangster' },
  { name: 'Psychological Thrillers' },
  { name: 'Slice of Life' },
  { name: 'Spy' },
  { name: 'Tragedy' },
  { name: 'Sketch Comedy' },
  { name: 'Pop Music' },
  { name: 'Martian Movies' },
]

export const years = [
  { value: '', label: '--' },
  { value: '2019', label: '2019' },
  { value: '2020', label: '2020' },
  { value: '2021', label: '2021' },
  { value: '2022', label: '2022' },
  { value: '2023', label: '2023' },
  { value: '2024', label: '2024' },
  { value: '2025', label: '2025' },
  { value: '2026', label: '2026' },
  { value: '2027', label: '2027' },
  { value: '2028', label: '2028' },
  { value: '2029', label: '2029' },
  { value: '2030', label: '2030' },
  { value: '2031', label: '2031' },
  { value: '2032', label: '2032' },
  { value: '2033', label: '2033' },
  { value: '2034', label: '2034' },
  { value: '2035', label: '2035' },
]
export const quarters = [
  { value: '', label: '--' },
  { value: '1st', label: '1st' },
  { value: '2nd', label: '2nd' },
  { value: '3rd', label: '3rd' },
  { value: '4th', label: '4th' },
]
